// extracted by mini-css-extract-plugin
export default {"root":"RW5BsNt6cU","text":"HehE0haCNC","root_large":"GeSpHpvfKK","text_new":"ggRhhABkMx","text_beta":"eTvXxmlROq","text_primary":"r9k0t2XDD6"};